$(function() {
    // var submitIcon = $('.searchbox-icon');
    // var inputBox = $('.searchbox-input');
    // var searchBox = $('.searchbox');
    // var searchLabel = $(".searchbox-label");
    // var isOpen = false;



});
